import { useCallback } from 'react';

import NiceModal, { useModal } from '@ebay/nice-modal-react';

import AddToEventDialog from 'components/dialogs/addToEventDialog/AddToEventDialog';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

interface ModalProps {
  participants: ParticipantInterface[];
  isTeam?: boolean;
  onResetRowSelection?: () => void;
}

const Modal = NiceModal.create(({ participants, ...props }: ModalProps) => {
  const modal = useModal();

  return (
    <AddToEventDialog
      open={modal.visible}
      participants={participants}
      onClose={modal.hide}
      onExited={modal.remove}
      {...props}
    />
  );
});

export const useAddToEventDialog = () =>
  useCallback(
    (participants: ModalProps['participants'], props?: Record<string, unknown>) =>
      NiceModal.show(Modal, { participants, ...props }),
    [],
  );
